export const quillColors = [
  'white',
  'black',
  'yellow',
  'red',
  'green',
  'amethyst',
  'magenta',
  'gray'
];

// Classes should be kept in sync with SASS $quill-colors variable
export const quillClasses = [
  'textColor-white',
  'textColor-black',
  'textColor-yellow',
  'textColor-red',
  'textColor-green',
  'textColor-amethyst',
  'textColor-magenta',
  'textColor-gray'
];



// WEBPACK FOOTER //
// ./src/utils/quill/constants.js